import { MY_ACCOUNT_URL } from '@in-life/constants';
import {
  BodyText,
  Button,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import SpotUnavailableLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg';

import { Dialog, DialogID, useDialog } from '@components/Dialog';

const InLifeSessionTimedOutDialog = () => {
  const dialog = useDialog(DialogID.IN_LIFE_SESSION_TIMED_OUT);

  const handleStartAgain = () => {
    dialog.setOpen(false);
    window.location.href = MY_ACCOUNT_URL;
  };

  return (
    <Dialog
      id={DialogID.IN_LIFE_SESSION_TIMED_OUT}
      hideCloseButton
      preventDismiss
    >
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        gap="200"
        padding="200"
      >
        <img
          src={SpotUnavailableLight}
          alt="Spot Unavailable"
          width={130}
          height={170}
          style={{ margin: '0 auto' }}
        />
        <Heading as="h1">Your session timed out</Heading>
        <Flex direction="column">
          <BodyText textAlign="center">
            Your session is no longer active.
          </BodyText>
          <BodyText textAlign="center">
            To continue, please head back to home.
          </BodyText>
        </Flex>
        <Flex
          direction="row"
          gap="100"
          width={{ mobile: '100%', tablet: 'fit-content' }}
          marginTop="200"
        >
          <Button
            variant="solid"
            onClick={handleStartAgain}
            style={{ width: '100%' }}
          >
            Back to home
          </Button>
        </Flex>
      </Flex>
    </Dialog>
  );
};

export { InLifeSessionTimedOutDialog };
